import { AddressAdapterInteface } from 'src/adapter/AddressAdapterInterface';
import { Prefecture, City } from 'src/models/enum/Address';
import axios from 'axios';
import { axiosErrorHandler } from 'src/error/handler/axiosErrorHandler';
const api = axios.create({
  baseURL: process.env.GET_PREFECTURE_CODE_BASE_URL,
});
export class AxiosAddressAdapter implements AddressAdapterInteface {
  async listPrefectures(): Promise<Prefecture[]> {
    try {
      const res = await api.get('/assets/areas/prefectures.json');
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async listCitiesPerPrefecture(pref_code: string): Promise<City[]> {
    try {
      const res = await api.get(`/assets/areas/cities_${pref_code}.json`);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
}
